// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.card-container .card-body {\n  padding: 0.875rem;\n}\n", ""]);
// Exports
module.exports = exports;
